import { render } from "./ClaimGrid.vue?vue&type=template&id=16aeec7b"
import script from "./ClaimGrid.vue?vue&type=script&lang=js"
export * from "./ClaimGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__